import React from 'react';
import { List } from 'antd';
import ResultItem from "./ResultItem";


const ResultPanel = ({ data }) => {
    return (
        <div className="result-panel">
            <List
                className="SearchResults"
                bordered={false}
                dataSource={data}
                itemLayout="horizontal"
                renderItem={(item) => <ResultItem item={item} />}
            />
        </div>
    )
}

export default ResultPanel;
